<template>
    <v-app v-resize="onResize">
        <header>
            <slot name="header"></slot>
        </header>

        <v-main class="main">
            <v-container fill-height color="#333">
                <slot name="main"></slot>
            </v-container>
        </v-main>

        <v-footer app color="#333">
            <slot name="footer"></slot>
        </v-footer>
    </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import rootActions from '../store/actions/root';

export default {
	name: 'Layout',
	methods: {
		...mapMutations([rootActions.SET_WINDOW_SIZE]),
		onResize() {
			this.SET_WINDOW_SIZE({ x: window.innerWidth, y: window.innerHeight });
		},
	},
};
</script>

<style lang="scss" scoped>
    .main {
        background-color: #333!important;
        .fill-height {
            align-items: initial;
        }
    }
</style>
